import * as $ from 'jquery';
import * as _ from 'underscore';
import * as moment from 'moment';

import Room from '../models/Room';

export default class RoomRepository {

    findAll(): JQueryPromise<Room[]> {
        return $.when( this.all );
    }

    findAvailable( from: moment.Moment, thru: moment.Moment ): JQueryPromise<Room[]> {
        return $.get('/api/rooms', { from: from.format('YYYY-MM-DD'),
                                     thru: thru.format('YYYY-MM-DD') }).
                 then( data => _.map(data, (r: any) => _.extend(
                     _.findWhere(this.all, { name: r.name }), { id: r.id } )) );
    }

    private get all(): Room[] {
        const _2f = [ '112', '114', '115', '116', '117' ];

        return _.reduce(
            [
                { kind: { name: 'M-2DBL',
                          abbr: 'm',
                          look: '/images/motel_room_l.jpg',
                          lo: 2,
                          hi: 4
                        },
                  rooms: [ '103', '104', '107', '108' ]
                },
                { kind: { name: 'E-2DBL',
                          abbr: 'e',
                          look: '/images/efficiency_room_l.jpg',
                          lo: 2,
                          hi: 4
                        },
                  rooms: [ '101', '102', '105', '106', '110', '115' ]
                },
                { kind: { name: 'E-QUEEN',
                          abbr: 'q',
                          look: '/images/efficiency_room_l.jpg',
                          hi: 2
                        },
                  rooms: [ '111' ]
                },
                { kind: { name: 'SUITE-KING',
                          abbr: 'k',
                          look: '/images/bedroom_suite_l.jpg',
                          lo: 2,
                          hi: 4
                        },
                  rooms: [ '116', '117' ]
                },
                { kind: { name: 'BR SUITE',
                          abbr: 's',
                          look: '/images/bedroom_suite_l.jpg',
                          lo: 2,
                          hi: 6
                        },
                  rooms: [ '109', '112', '114' ]
                }
            ].map(
                byKind => byKind.rooms.map(
                    r => new Room(undefined, r, _.contains(_2f, r) ? '2f' : '1f', byKind.kind)
                )
            ),
            (rooms, byKind) => rooms.concat( byKind ),
            []
        )
    }

}



/** WEBPACK FOOTER **
 ** ./src/repositories/RoomRepository.ts
 **/